import { useEffect, useState } from "react";
import { defaultPayloadMapping } from "../../../Models/WebhookTrigger/payloadMapping";

export default function usePayloadMapping(
  payloadMapping,
  onUpdatePayloadMapping,
) {
  const [payloadMappings, setPayloadMappings] = useState(payloadMapping);

  const [payloadMappingDialog, setPayloadMappingDialog] = useState({
    mode: undefined,
    mapping: undefined,
    mappingIdx: -1,
  });

  useEffect(() => {
    onUpdatePayloadMapping(payloadMappings);
  }, [payloadMappings]);

  const openAddPayloadMappingDialog = () => {
    setPayloadMappingDialog({
      mode: "add",
      mapping: defaultPayloadMapping,
      mappingIdx: -1,
    });
  };

  const openEditPayloadMappingDialog = (mapping, mappingIdx) => {
    setPayloadMappingDialog({
      mode: "edit",
      mapping,
      mappingIdx,
    });
  };

  const closePayloadMappingDialog = () => {
    setPayloadMappingDialog({
      mode: null,
      mapping: null,
      mappingIdx: -1,
    });
  };

  const addPayloadMapping = (mapping) => {
    setPayloadMappings((prev) => {
      return [...prev, mapping];
    });
  };

  const removePayloadMapping = (mappingIdx) => {
    setPayloadMappings((prev) => {
      return prev.toSpliced(mappingIdx, 1);
    });
  };

  const updatePayloadMapping = (mapping, mappingIdx) => {
    setPayloadMappings((prev) => {
      return prev.toSpliced(mappingIdx, 1, mapping);
    });
  };

  // Replaces the whole list at once (used by the voice-agent auto-fill).
  const replacePayloadMappings = (mappings) => {
    setPayloadMappings(mappings);
  };

  return {
    payloadMappings,
    addPayloadMapping,
    removePayloadMapping,
    updatePayloadMapping,
    replacePayloadMappings,
    payloadMappingDialog,
    openAddPayloadMappingDialog,
    openEditPayloadMappingDialog,
    closePayloadMappingDialog,
  };
}
